import * as React from 'react';
import { Link } from '../Link';
import { TrackComponent } from '../TrackComponent';
import { PhoneIcon } from '../Icons/PhoneIcon';
import { TestSelector } from '../../helpers/TestSelector';
import * as Colors from '../../consts/variables';
import { IStyles } from '../../interfaces/IStyles';

const styles: IStyles = {
    icon: {
        display: 'inline-block',
        textDecoration: 'none',
    },
    svg: {
        fill: Colors.lighterBlack,
        stroke: Colors.lighterBlack,
        strokeWidth: 12,
    },
};
const TrackableLink = TrackComponent(Link, {
    category: 'mobile-contact us',
    action: 'phone icon',
});
interface IProps {
    phoneNumber: string;
    testSelectorName?: string;
}

export class Phone extends React.Component<IProps, {}> {
    render() {
        return (
            <TrackableLink
                {...TestSelector.getSelector('header-phone')}
                style={styles.icon}
                href={`tel:${this.props.phoneNumber}`}
            >
                <PhoneIcon style={styles.svg} width={26} height={26} />
            </TrackableLink>
        );
    }
}
